import { useState, useLayoutEffect } from 'react';

const useOverflow = (ref: React.RefObject<HTMLElement>) => {
  const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined);

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      // Since we only run the trigger function if content is defined, we can safely use ! to access the properties
      const hasOverflow = current!.scrollWidth > current!.clientWidth;

      setIsOverflow(hasOverflow);
    };

    if (current) {
      trigger();
    }
  }, [
    ref,
  ]);

  return isOverflow;
};

export default useOverflow;
